import dayjs from 'dayjs';
import { BookingDepositType } from 'shared/types/booking';

const _getDepositAmountByDate = (
	deposit?: BookingDepositType,
	time?: string,
	originDate?: string
) => {
	if (!deposit?.active) return 0;

	if (!deposit.schedule) return deposit.amount;

	if (!time) return 0;

	const date = dayjs(time);
	for (let day of deposit.schedule.dates ?? []) {
		const dateFrom = dayjs(`${day.date} ${day.from}`);
		let dateTill = dayjs(`${day.date} ${day.till}`);

		if (dateFrom.isAfter(dateTill)) {
			dateTill = dateTill.add(1, 'days');
		}

		const isAfterValid = date.isAfter(dateFrom) || date.isSame(dateFrom);
		const isBeforeValid = date.isBefore(dateTill);

		if (isAfterValid && isBeforeValid) {
			return day.amount;
		}
	}

	const currentDate = dayjs(originDate ?? date); // for cases that is extended to next day we should take original date

	for (let day of deposit.schedule.recurring ?? []) {
		if (currentDate.day() === day.dayOfWeek) {
			const dateFrom = dayjs(`${currentDate.format('YYYY-MM-DD')} ${day.from}`);
			let dateTill = dayjs(`${currentDate.format('YYYY-MM-DD')} ${day.till}`);

			if (dateFrom.isAfter(dateTill)) {
				dateTill = dateTill.add(1, 'days');
			}

			const isAfterValid = date.isAfter(dateFrom) || date.isSame(dateFrom);
			const isBeforeValid = date.isBefore(dateTill);

			if (isAfterValid && isBeforeValid) {
				return day.amount;
			}
		}
	}

	return 0;
};

export const BookingStateHelpers = {
	getDepositAmountByDate: _getDepositAmountByDate,
};
